exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-popover.region-selector-wrap{margin-top:0!important;padding:0;background:none;-webkit-box-shadow:none;box-shadow:none;border:none\n}", "", {"version":3,"sources":["/home/jenkins/workspace/pipeline-10323-UAT-kmos-web-ci-cd-6005/html/PC/src/components/common/regionSelector.vue"],"names":[],"mappings":";AACA,iCAAiC,uBAAuB,UAAU,gBAAgB,wBAAwB,gBAAgB,WAAW;CACpI","file":"regionSelector.vue","sourcesContent":["\n.el-popover.region-selector-wrap{margin-top:0!important;padding:0;background:none;-webkit-box-shadow:none;box-shadow:none;border:none\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20a4879b","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./node_modules/style-rem-loader??ref--1!./src/components/common/regionSelector.vue
// module id = 1028
// module chunks = 2